import BreadcrumbView from "../../common/breadcrumb/breadcrumb.html";
import LocationsListView from "./locations-list.html";
import LocationsEditView from "./locations-edit.html";

angular.module("locations", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('locations', {
                url: "/locations",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('locations.list', {
                url: "/list",
                controller: "LocationsListCtrl",
                template: LocationsListView,
                requiredPermission: ["LOCATIONS_WRITE"]
            })
            .state('locations.edit', {
                url: "/edit/:id",
                controller: "LocationsEditCtrl",
                template: LocationsEditView,
                requiredPermission: ["LOCATIONS_WRITE"]
            })
    }])
;